var map = {
	"./86/Spectate/SILinks.mobile.layout.js": [
		82241,
		[
			9315
		]
	],
	"./86/Spectate/SILinks.pc.layout.js": [
		25160,
		[
			3434
		]
	],
	"./89/Spectate/SILinks.mobile.layout.js": [
		54922,
		[
			1698
		]
	],
	"./89/Spectate/SILinks.pc.layout.js": [
		39143,
		[
			6275
		]
	],
	"./90/Spectate/SILinks.mobile.layout.js": [
		19508,
		[
			9244
		]
	],
	"./90/Spectate/SILinks.pc.layout.js": [
		23109,
		[
			961
		]
	],
	"./91/Spectate/SILinks.mobile.layout.js": [
		26517,
		[
			8183
		]
	],
	"./91/Spectate/SILinks.pc.layout.js": [
		19404,
		[
			6062
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 26957;
module.exports = webpackAsyncContext;